import { BlogData } from '../types';

// Eigenständiger Blog (nicht die Work-Case-Studies): Politisches und
// Gesellschaftliches, Essays und Meinungsstücke.
// Artikel-Bodies liegen als Markdown unter src/data/blog-content/.
const blogData: BlogData = {
  title: "Blog",
  intro: "Politisches und Gesellschaftliches, das mich umtreibt. Essays abseits der Projektarbeit.",
  posts: [
    {
      slug: "wie-viel-disruption-vertraegt-der-mensch",
      title: "Wie viel Disruption verträgt der Mensch?",
      date: "2026-10-02",
      teaser: "Das Auto hatte ein Jahrhundert, das Internet ist nach 30 Jahren noch Neuland, und KI kommt obendrauf. Ein Essay darüber, warum Gesellschaften nicht mehr hinterherkommen, warum diesmal die Konzerne selbst die Disruptoren sind und warum Regulierung keine Spaßbremse ist.",
      tags: ["KI", "Disruption", "Gesellschaft", "Regulierung", "Big Tech", "Essay"],
      readingMinutes: 13,
      image: "/assets/img/blog/wie-viel-disruption-vertraegt-der-mensch_og.webp"
    }
  ]
};

export default blogData;
